import React from 'react';
import { AwardIcon, GraduationCapIcon, SchoolIcon, ScissorsIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { audience } from '../../data/content';
const icons = [GraduationCapIcon, SchoolIcon, ScissorsIcon, AwardIcon];
const tints = ['#F9DCD3', '#D5EEDC', '#CFE4F5', '#E6D6F3'];
export function AudienceSection() {
  return <section aria-labelledby="audience-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-45" data-mp="1tbv7g62e7pe4">
      <div className="mx-auto max-w-5xl" data-id="element-46" data-mp="237pwpk14gipv">
        <SectionHeading id="audience-heading" title={<>
              Created for Professionals Who <Accent data-id="element-48" data-mp="2gybhjea4z2qe">Teach Hair Extensions</Accent>
            </>} data-id="element-47" data-mp="236n5fazw0e9f" />

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" role="list" data-id="element-49" data-mp="2cy1eoahn4sfr">
          {audience.map((item, index) => {
          const Icon = icons[index];
          return <li key={item.title} className="flex flex-col items-center rounded-[20px] bg-white px-5 py-7 text-center" data-id="element-50" data-mp="2lziq3fk3s5y4" data-mpi={index}>
                <span className="flex h-12 w-12 items-center justify-center rounded-full" style={{
              backgroundColor: tints[index]
            }} data-id="element-51" data-mp="1sdf3a1ozgf95">
                  <Icon className="h-5 w-5 text-brand-charcoal" strokeWidth={1.5} aria-hidden="true" data-id="element-52" data-mp="22872tb24lc6k" />
                </span>
                <h3 className="mt-4 font-display text-[1.2rem] font-bold leading-tight text-brand-charcoal" data-id="element-53" data-mp="2690p5zzx6ixc">
                  {item.title}
                </h3>
                <p className="mt-2 text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-54" data-mp="2g88dfi86zxz8">{item.text}</p>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl text-center text-[13px] leading-relaxed text-brand-charcoal/60" data-id="element-55" data-mp="2pz318r1375ms">
          Designed as an educational resource for instructors and qualified professionals. It does not replace
          hands-on certification, manufacturer training, or applicable licensing requirements.
        </p>
      </div>
    </section>;
}